import gtag_event from './gtag-init';
import {insert_leads_to_db} from '../../global/leads-submission';

var selected_property;

export default {
  init() {
    // <!------------------ Event Tracker
    // track pageview
    setTimeout(function() {
      gtag_event('Visit');
    }, 1500);

    var current_form_class = '.compare-cta-form',
      btn_submit = '#compare-cta-submit',
      name_field = $('.compare-cta-form [name="name"]'),
      number_field = $('.compare-cta-form [name="whatsapp_number"]'),
      alert_field = $('.compare-cta-form .message-failed'),
      process_submit = false;

    // scroll event
    var content = $('section');
    var current_section_id = null;

    $(window).on('scroll', function () {
      let el = content.filter(function (i, el) {
        return el.getBoundingClientRect().bottom >= parseInt($(el).css('height'))
      });
      let section_id = el.prev().is(content) ? el.prev('section').attr('id') : content.eq(-1).attr('id');

      if (section_id != current_section_id) {
        current_section_id = section_id;

        // track pageview
        gtag_event('Vertical Scroll', current_section_id);
      }

      check_scroll_position(current_section_id);
    });

    function check_scroll_position(current_section_id) {
      let the_end_of_section = 'section-footer';
      let scroll_height = $(document).height();
      let scroll_position = $(window).height() + $(window).scrollTop();

      if ((scroll_height - scroll_position) / scroll_height === 0 && current_section_id != the_end_of_section) {
        gtag_event('Vertical Scroll', the_end_of_section);
      }
    }

    function is_mobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        return true;
      }else{
        return false;
      }
    }

    function whatsapp_base_url() {
      if( is_mobile() ) {
        return 'https://api.whatsapp.com';
      }

      return 'https://web.whatsapp.com';
    }

    /**
      * Check any required field to change the button state
      */
    function check_vt_form_field() {

      var disable_form = false;

      $('.compare-cta-form').find('.form-required').each(function (i, el) {

        if ('' === $(el).val()) {
          disable_form = true;
        }
      });

      if (disable_form) {
        $('#compare-cta-submit').attr('disabled', true);
      } else {
        $('#compare-cta-submit').attr('disabled', false);
      }
    }

    check_vt_form_field();

    $('.form-required').on('change', function () {
      check_vt_form_field();
    });

    /**
     * Validate whatsapp field
     */
    function whatsapp_validation_form() {
      var alert = '';
      var number = whatsapp_clean_number();

      if (name_field == '') {
        alert = 'Silakan isi nama';
      }

      if (number == '') {
        alert = 'Silakan isi nomor Whatsapp';
      } else if (number.charAt(0) == 0) {
        alert = 'Nomor salah. Silakan gunakan kode negara. Contoh: 628123456789';
      }

      if (alert == '') {
        return true;
      }

      alert_field.text(alert).show();
      return false;
    }

    /**
     * Clean whatsapp number
     */
    function whatsapp_clean_number() {
      var number = number_field.val();

      // remove non numeric
      number = number.replace(/\D/g, '');

      if (number != '') {
        // change first zero
        number = change_zero_to_country_code(number);
      }

      number_field.val(number);

      return number;
    }

    function change_zero_to_country_code(number) {
      if (number.charAt(0) == 0) {
        return '62' + number.substr(1);
      }

      return number;
    }

    function redirect_submit_whatsapp_form() {
      var project_name = $(current_form_class + ' [name=project_name]').val();
      var telesales_number = $(current_form_class + ' [name=telesales_number]').val();
      var whatsapp_link;

      $('#compare-form-modal .modal-title-lg').html('Terima kasih atas kiriman anda');
      $('#compare-form-modal .hide-after-submit').hide();
      $('#compare-form-modal .modal-content label').hide();
      $('#compare-form-modal .modal-content input').hide();
      $('#compare-form-modal .modal-content button').hide();
      $('#compare-form-modal .alert-warning').hide();
      $('#compare-form-modal .message-success').show();

      whatsapp_link = whatsapp_base_url()+'/send?text=Saya%20ingin%20bertanya%20mengenai%20info%20' + project_name + '&phone=' + telesales_number;

      $('#compare-page-redirect-link').attr('href', whatsapp_link);

      setTimeout(function () {
        location.href = whatsapp_link;
      }, 2000); // 2 second
    }

    function submit_whatsapp_form(data) {

      if (data == -1 || data == '') {
        alert_field.text('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.').show();
        return;
      }

      if (data.success) {
        // submit success
        $(current_form_class + ' [name=submit_status]').val('1').trigger('change');

        // send GA tracking
        gtag_event('Whatsapp Submission', 'comparison');

        redirect_submit_whatsapp_form();
      } else {
        $(current_form_class + ' .message-success').hide();
        $(current_form_class + ' .message-failed').html('<p>' + data.data.message + '</p>').show();
        $(current_form_class + ' .loader').hide();
      }
    }

    $('.compare-cta-form').on('submit', function (e) {

      e.preventDefault();

      if (whatsapp_validation_form() == false) {
        return false;
      }

      if (true === process_submit) {
        alert('Mohon ditunggu, data anda sedang diproses');
        return;
      }

      let data_form = $(this).serialize() + '&current_url=' + $(location).attr('href');

      // insert leads data to DB
      insert_leads_to_db($(this));

      $.ajax({
        type: $(this).attr('method'),
        url: $(this).attr('action'),
        data: data_form,
        beforeSend: function () {
          $(current_form_class + ' .message-text').hide();
          $(current_form_class + ' .message-success').hide();
          $(current_form_class + ' .message-failed').hide();
          $(current_form_class + ' .loader').show();
          $(btn_submit).prop('disabled', true);
          process_submit = true;
        },
        success: function (data) {
          $(current_form_class + ' .message-success').hide();
          submit_whatsapp_form(data);
          $(btn_submit).prop('disabled', false);
          process_submit = false;
        },
        error: function (data) {
          console.log('An error occurred.');
          console.log(data);
          $(btn_submit).prop('disabled', false);
          process_submit = true;
        },
      });
    });

    var nnp_render_selected_property = function() {
      $('body').addClass('compared-property');

      $('.data-1.image').html($('<textarea />').html(selected_property.image).text());

      $.each( selected_property, function(i, e){

        if( i != 'image') {
          if( i === 'property' ) {
            $.each(e, function(i2, e2){

              if (0 < $('.data-1.' + i2).length) {
                $('.data-1.' + i2).html(e2);
              }

            });
          } else {

            if (0 < $('.data-1.' + i).length) {
              $('.data-1.' + i).html(e);
            }

          }
        }

      });
    }

    $('.open-modal-compare').on('click', function(){
      $('#compare-project-popup').modal('show');
      
    });

    $('#compare-project-form').on('submit', function(){
      var selected = $('#compare-project-selection').val();
      
      // eslint-disable-next-line no-undef
      if(global_params['properties']['data'][selected] !== undefined) {
        // eslint-disable-next-line no-undef
        selected_property = global_params['properties']['data'][selected];

        let current_url = window.location.href.split('?')[0];
        
        // nnp_render_selected_property();

        gtag_event('Comparison action', 'click_bandingkan');

        $('#compare-project-popup').modal('hide');

        window.open(current_url + '?compare=' + selected_property.post_name, '_self' );

        return false;

      } else {
        alert('Wrong property data');
      }

      return false;
    });

    $('.compare-cta-button').on('click', function(){
      gtag_event('Whatsapp Button Clicked', 'comparison');
      $('#compare-form-modal').modal('show');
      return false;
    });

    $(window).on('load', function(){
      // eslint-disable-next-line no-undef
      if( typeof nnp_selected !== 'undefined') {
        // eslint-disable-next-line no-undef
        if (global_params['properties']['data'][nnp_selected.property] !== undefined) {
          // eslint-disable-next-line no-undef
          selected_property = global_params['properties']['data'][nnp_selected.property];

          nnp_render_selected_property();
          gtag_event('Comparison action', 'click_bandingkan');
        } else {
          alert('Wrong property data');
        }
      }
    });

    $('#section-project-h2h h5').on('click', function(){
      var target = $(this).data('target');

      $(this).toggleClass('open');

      $('.row.list-data.data-' + target).each(function(i, el){
        $(el).toggle('fast');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the page template, after the init JS
  },
};


// WEBPACK FOOTER //
// ./scripts/page-template/comparison/page.js